import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import BtbOrderReport from './BtbOrderReport';
import * as reportAction from '../../../../../actions/reportAction';

const mapStateToProps = state => {
    return {
        btbOrderState: state.reportReducer.btbOrderReport,
        loadingBtbOrder: state.reportReducer.isFetchingBtbOrder,
        isFetchingExportBtbOrder: state.reportReducer.isFetchingExportBtbOrder
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBtbOrderReport: (filters) => dispatch(reportAction.getBtbOrderReport(filters)),
        getExportBtbOrderReport: (data) => dispatch(reportAction.getExportBtbOrderReport(data)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(BtbOrderReport));